/*
* Bootstrap
* https://getbootstrap.com/docs/4.4/getting-started/introduction/
*/
require('./bootstrap');

/*
* Bootstrap Table
* https://bootstrap-table.com/
*/
require('bootstrap-table');

/*
* Bootstrap Table Cookies
* Used to save the search value
* https://bootstrap-table.com/docs/extensions/cookie/
*/
require('bootstrap-table/src/extensions/cookie/bootstrap-table-cookie');

/*
* Bootstrap Table
* Add translations for each language
*/
if($('html').attr('lang') == 'de'){
	require('bootstrap-table/src/locale/bootstrap-table-de-DE');
}else if($('html').attr('lang') == 'fr'){
	require('bootstrap-table/src/locale/bootstrap-table-fr-CH');
}

/*
* Select 2
* https://select2.org/
*/
require('select2');

/*
* Autosize
* https://github.com/jackmoore/autosize
*/
window.autosize = require('autosize');

/*
* SortableJS
* http://sortablejs.github.io/Sortable/
*/
import Sortable from 'sortablejs';
window.Sortable = Sortable;

/*
* Toastr
* https://github.com/CodeSeven/toastr
* https://codeseven.github.io/toastr/
*/
window.toastr = require("toastr");

/*
* Moment.js
* https://momentjs.com/docs/
*/
import moment from 'moment';
window.moment = moment;
if($('html').attr('lang') == 'de'){
	moment.locale('de-CH');
}else if($('html').attr('lang') == 'fr'){
	moment.locale('fr-CH');
}

/*
* Datepicker
* https://github.com/flatpickr/flatpickr
* https://flatpickr.js.org/
*/
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";

/*
* CKEditor 5
* https://ckeditor.com/docs/ckeditor5/latest/index.html
*/
window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');

//Object used to take track of some changes
window.pageVar = {};

// User id
window.userId = $('meta[name="user-id"]').attr('content');

// Custom js from BlueMouse GmbH
require('./main');

require('./order')

